import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	editLabel: {
		id: 'servicedesk-reports-common.overall-summary.edit-label',
		defaultMessage: 'Edit',
		description: 'Edit label for overall summary',
	},
	removeLabel: {
		id: 'servicedesk-reports-common.overall-summary.remove-label',
		defaultMessage: 'Remove',
		description: 'Remove label for overall summary',
	},
});
